import React from "react";
import appNameImg from "../../assets/app_name.png";
import videoCallImg from "../../assets/video_call.png";
const HeroComponent = () => {
  return (
    <>
      <p>遠く離れた人と一緒にチャットや通話しながら</p>
      <p>食事や料理がお手軽に楽しめるコミュニケーションアプリ</p>
      <div className="app-name-img">
        <img src={appNameImg} />
      </div>
      <div className="video-call-img">
        <img src={videoCallImg} />
      </div>
    </>
  );
};
export default HeroComponent;